$w.onReady(function () {
    $w("#footer1").children.forEach((item, i) => {
        item.collapse();
    });
});